module.exports = __webpack_public_path__ + "img/u285.6854913a.svg";